const dateFromTimestamp = (
  timestamp: string | number | Date | undefined,
): string => {
  if (timestamp) {
    const date = new Date(timestamp);
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };

    return date.toLocaleDateString('en-US', options);
  }
  return '';
};

export default dateFromTimestamp;
